<template>
    <div class="flex flex-col lg:flex-row gap-4">
        <div class="flex flex-col gap-3">
            <div class="p-4 rounded bg-maroon">
                <h5 class="text-lg text-white">Eyes</h5>

                <ul class="list-disc pl-4 font-light">
                    <li class="text-white">Visual impairment<sup>1</sup></li>
                </ul>
            </div>

            <div class="p-4 rounded text-white bg-purple">
                <h5 class="text-lg text-white">Heart</h5>

                <ul class="list-disc pl-4 font-light">
                    <li class="text-white">
                        Infiltrative cardiomyopathy with restrictive physiology or conductive disturbances<sup>1</sup>
                    </li>
                </ul>
            </div>

            <div class="p-4 rounded bg-darkPink">
                <h5 class="text-lg text-white">Bone</h5>

                <ul class="list-disc pl-4 font-light">
                    <li class="text-white">Low-trauma fractures, bone deformation, pain, <br />poor longitudinal growth<sup>1</sup></li>
                    <li class="text-white">Erythropoietin-refractory anemia<sup>1</sup></li>
                </ul>
            </div>

            <div class="p-4 rounded bg-gold">
                <h5 class="text-lg text-white">Psychological Impacts</h5>

                <ul class="list-disc pl-4 font-light">
                    <li class="text-white">
                        Patients with PH1 may experience fear and stress due to the unpredictable nature of disease
                        progression and kidney stone occurrence, which impact their QoL<sup>2</sup>
                    </li>
                </ul>
            </div>

            <div class="p-4 rounded  bg-darkerblue">
                <h5 class="text-lg text-white">Skin</h5>

                <ul class="list-disc pl-4 font-light">
                    <li class="text-white">Skin nodules and ulcers<sup>1</sup></li>
                </ul>
            </div>
        </div>

        <img
            src="@/assets/img/disease-burden.svg"
            alt="Disease burden person"
            class="object-contain"
            :style="{ maxHeight: '510px' }"
        />

        <div class="flex flex-col lg:max-w-80 gap-4 lg:gap-6 justify-center">
            <div class="p-9 rounded border-solid border-2 border-purple font-light text-center">
                As <span class="font-semibold">eGFR declines</span>,oxalate clearance is reduced, leading to an increase in plasma concentrations of
                oxalate until the supersaturation point is reached and <span class="font-semibold">systemic oxalate deposition</span> occurs<sup>1</sup>
            </div>

            <div class="p-9 rounded border-solid border-2 border-lightblue font-light text-center">
                PH1 can have a devastating and life-threatening impact on patients as a consequence of systemic
                oxalosis<sup>1,3-5</sup>
            </div>
        </div>
    </div>

    <div class="p-4 bg-lightblue50  font-semibold my-6 text-center">
        PH1 complications, and the fear of disease progression, can have a psychological and emotional impact on
        patients.<sup>2</sup> Appropriate management may delay disease progression to systemic oxalosis by slowing the
        build-up of systemic oxalate to maintain POx levels below the supersaturation point for as long as possible<sup>3-5</sup>
    </div>

    <h4 class="text-center text-xl font-semibold mt-3">These are not all the signs and symptoms of systemic oxalosis</h4>
</template>
